// Utils
import { isArray } from 'lodash';

// Components
import SendEmailsModal from 'shared/ui/components/modals/SendEmailsModal.vue';

export default {

    methods: {
        /**
         * Open modal to send emails to the specified users
         * @param {Object} [event]
         * @param {Pax|Pax[]} [users=[]]
         * @param {string} recipientsFpType the type of the receivers (may be prospect, defaulted to user)
         * @param {Object} [templateVariables={}] template specific variables
         */
        openEmailModal(event, users = [], templateVariables = {}, recipientsFpType = 'person') {
            if (!isArray(users)) {
                users = [users];
            }

            const recipientsExtIds = users.map(u => u.fp_ext_id);
            const unsubscribed = users.filter(u => u.unsubscribed_from_emails).map(u => u.fp_ext_id);

            this.$modal.show(SendEmailsModal, {
                event,
                recipientsExtIds,
                unsubscribedFromEmails: unsubscribed,
                templateVariables,
                recipientsFpType,
                onSuccess: this.onSendEmailSuccess.bind(this)
            }, {
                clickToClose: false,
                height: 'auto'
            });
        },

        onSendEmailSuccess() {
            // Optionally overwrite on including component
        }
    }
};
